import Layout from "@/layout";

const coreRouter = {
  path: "/core",
  component: Layout,
  redirect: "/core/microarchitecture",
  name: "Core",
  meta: {
    title: "RISC-V Core Generator",
    icon: "nested",
  },
  children: [
    {
      path: "microarchitecture",
      name: "MicroArchitecture",
      component: () => import("@/views/core/microarchitecture/index"),
      meta: {
        title: "Micro Architecture",
        keepAlive: true,
      },
    },

    {
      path: "menu2",
      name: "Menu2",
      component: () => import("@/views/core/menu2/index"),
      meta: {
        title: "Custom Instruction & Compiler Tools-chain",
      },
    },
    {
      path: "software",
      name: "software",
      component: () => import("@/views/core/software/index"),
      meta: {
        title: "Fundamental SW Lib",
      },
    },
  ],
};

export default coreRouter;
